export type RegistrationChildInput = {
  name: string
  birthday: string
  needsEquipment: boolean
  needsLiftTicket: boolean
}

export function campAsksEmergencyEquipment(camp: {
  askEmergencyEquipmentInRegistration?: boolean | null
}): boolean {
  return camp.askEmergencyEquipmentInRegistration === true
}

export function campAsksMultiPitchInterest(camp: {
  askMultiPitchInterestInRegistration?: boolean | null
}): boolean {
  return camp.askMultiPitchInterestInRegistration === true
}

export function campOffersLiftTicket(camp: { liftTicketAvailable?: boolean | null }): boolean {
  return camp.liftTicketAvailable === true
}

export function normalizeLiftTicketSelection(
  offersLift: boolean,
  needsLiftTicket: boolean,
  children: RegistrationChildInput[],
): {
  needsLiftTicket: boolean
  children: RegistrationChildInput[]
} {
  if (!offersLift) {
    return {
      needsLiftTicket: false,
      children: children.map((c) => ({ ...c, needsLiftTicket: false })),
    }
  }
  return { needsLiftTicket, children }
}

export function normalizeRegistrationEquipmentAndMultiPitch(
  askEquipment: boolean,
  askMultiPitch: boolean,
  input: {
    needsEquipment: boolean
    interestMultiPitch: boolean
    children: RegistrationChildInput[]
  },
): {
  needsEquipment: boolean
  interestMultiPitch: boolean
  children: RegistrationChildInput[]
} {
  return {
    needsEquipment: askEquipment && input.needsEquipment,
    interestMultiPitch: askMultiPitch && input.interestMultiPitch,
    children: input.children.map((c) => ({
      ...c,
      needsEquipment: askEquipment && c.needsEquipment,
    })),
  }
}
